import { render, staticRenderFns } from "./SystemRequirementsTable.vue?vue&type=template&id=4c67d5ec&scoped=true"
import script from "./SystemRequirementsTable.vue?vue&type=script&lang=js"
export * from "./SystemRequirementsTable.vue?vue&type=script&lang=js"
import style0 from "./SystemRequirementsTable.vue?vue&type=style&index=0&id=4c67d5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67d5ec",
  null
  
)

export default component.exports
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QMarkupTable,QItem,QItemSection,QIcon});
